export default __webpack_public_path__ + "static/media/warp.1f9bec85.mp3";